// extracted by mini-css-extract-plugin
export default {"root":"NotificationBadge_root__Fxlz6","neutral":"NotificationBadge_neutral__cjdsQ"};